import { render, staticRenderFns } from "./UserCrud.vue?vue&type=template&id=98b116ae&scoped=true&"
import script from "./UserCrud.vue?vue&type=script&lang=js&"
export * from "./UserCrud.vue?vue&type=script&lang=js&"
import style0 from "./UserCrud.vue?vue&type=style&index=0&id=98b116ae&prod&scoped=true&lang=css&"
import style1 from "./UserCrud.vue?vue&type=style&index=1&id=98b116ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b116ae",
  null
  
)

export default component.exports